/**
 * Zurich's primary colors. All naming conventions reflect
 * those found in Figma except Lighter Dove.
 *
 * @property Zurich Blue
 * @property Mid Blue
 * @property Dark Blue
 * @property Light Blue
 * @property Sky Blue
 * @property Sky Blue AA
 * @property Sand Stone
 * @property Dove
 * @property Light Dove
 * @property Lighter Dove
 * @property Zurich White
 * @property Connect Orange
 * @property Alice Blue
 */
export const primary = {
    /**
     * Zurich Blue
     */
    zurichBlue: '#2167AE',
    /**
     * Mid Blue
     */
    midBlue: '#5495CF',
    /**
     * Dark Blue
     */
    darkBlue: '#23366F',
    /**
     * Light Blue
     */
    lightBlue: '#91BFE3',
    /**
     * Sky Blue
     */
    skyBlue: '#1FB1E6',
    /**
     * Sky Blue AA
     */
    skyBlueAA: '#1393D1',
    /**
     * Sand Stone
     */
    sandStone: '#DAD2BD',
    /**
     * Dove
     */
    dove: '#DDE4E3',
    /**
     * Light Dove
     */
    lightDove: '#E4E9EC',
    /**
     * Lighter Dove
     */
    lighterDove: '#F3F9FD',
    /**
     * Zurich White
     */
    zurichWhite: '#ECEEEF',
    /**
     * Connect-Orange
     */
    connectOrange: '#E06717',
    /**
     * Alice-Blue
     */
    aliceBlue: '#f7f9fc',
    /**
     * Orange-100 (previous Orange alte CI)
     */
    orange100: '#F69C00',
    /**
     * Zurich Azure
     */
    zurichAzure: '#f7fbfb',
};
/**
 * Zurich Azure
 *
 * @property Azure-100
 * @property Azure-80
 * @property Azure-60
 * @property Azure-40
 * @property Azure-20
 */
export const azure = {
    /**
     * Azure-100
     */
    100: '#4870C6',
    /**
     * Azure-80
     */
    800: '#6D8DD1',
    /**
     * Azure-60
     */
    600: '#91A9DD',
    /**
     * Azure-40
     */
    400: '#B6C6E8',
    /**
     * Azure-20
     */
    200: '#DAE2F4',
};
/**
 * Zurich Moss
 *
 * @property Moss-100
 * @property Moss-80
 * @property Moss-60
 * @property Moss-40
 * @property Moss-20
 * @property Moss-AA
 */
export const moss = {
    /**
     * Moss-100
     */
    100: '#77A984',
    /**
     * Moss-80
     */
    800: '#92BA9D',
    /**
     * Moss-60
     */
    600: '#ADCBB5',
    /**
     * Moss-40
     */
    400: '#C9DDCE',
    /**
     * Moss-20
     */
    200: '#E4EEE6',
    /**
     * Moss-AA
     */
    A100: '#428351',
};
/**
 * Zurich Teal
 *
 * @property Teal-100
 * @property Teal-80
 * @property Teal-60
 * @property Teal-40
 * @property Teal-20
 * @property Teal-AA
 */
export const teal = {
    /**
     * Teal-100
     */
    100: '#19BAB6',
    /**
     * Teal-80
     */
    800: '#47C8C5',
    /**
     * Teal-60
     */
    600: '#75D6D3',
    /**
     * Teal-40
     */
    400: '#A3E3E2',
    /**
     * Teal-20
     */
    200: '#D1F1F0',
    /**
     * Teal-AA
     */
    A100: '#088487',
};
/**
 * Zurich Mint
 *
 * @property Mint-100
 * @property Mint-80
 * @property Mint-60
 * @property Mint-40
 * @property Mint-20
 */
export const mint = {
    /**
     * Mint-100
     */
    100: '#A6E9AB',
    /**
     * Mint-80
     */
    800: '#B8EDBC',
    /**
     * Mint-60
     */
    600: '#CAF2CD',
    /**
     * Mint-40
     */
    400: '#DBF6DD',
    /**
     * Mint-20
     */
    200: '#EDFBEE',
};
/**
 * Zurich Lime
 *
 * @property Lime-100
 * @property Lime-80
 * @property Lime-60
 * @property Lime-40
 * @property Lime-20
 */
export const lime = {
    /**
     * Lime-100
     */
    100: '#E1EE92',
    /**
     * Lime-80
     */
    800: '#E7F1A8',
    /**
     * Lime-60
     */
    600: '#EDF5BE',
    /**
     * Lime-40
     */
    400: '#F3F8D3',
    /**
     * Lime-20
     */
    200: '#F9FCE9',
};
/**
 * Zurich Lemon
 *
 * @property Lemon-100
 * @property Lemon-80
 * @property Lemon-60
 * @property Lemon-40
 * @property Lemon-20
 * @property Lemon-AA
 */
export const lemon = {
    /**
     * Lemon-100
     */
    100: '#FFF773',
    /**
     * Lemon-80
     */
    800: '#FFF98F',
    /**
     * Lemon-60
     */
    600: '#FFFAAB',
    /**
     * Lemon-40
     */
    400: '#FFFCC7',
    /**
     * Lemon-20
     */
    200: '#FFFDE3',
    /**
     * Lemon-AA
     */
    A100: '#FFC828',
};
/**
 * Zurich Peach
 *
 * @property Peach-100
 * @property Peach-80
 * @property Peach-60
 * @property Peach-40
 * @property Peach-20
 * @property Peach-AA
 */
export const peach = {
    /**
     * Peach-100
     */
    100: '#FF7569',
    /**
     * Peach-80
     */
    800: '#FF9187',
    /**
     * Peach-60
     */
    600: '#FFACA5',
    /**
     * Peach-40
     */
    400: '#FFC8C3',
    /**
     * Peach-20
     */
    200: '#FFE3E1',
    /**
     * Peach-AA
     */
    A100: '#CB4B40',
};
/**
 * Zurich Candy
 *
 * @property Candy-100
 * @property Candy-80
 * @property Candy-60
 * @property Candy-40
 * @property Candy-20
 * @property Candy-AA
 */
export const candy = {
    /**
     * Candy-100
     */
    100: '#E18EBA',
    /**
     * Candy-80
     */
    800: '#E7A5C8',
    /**
     * Candy-60
     */
    600: '#EDBBD6',
    /**
     * Candy-40
     */
    400: '#F3D2E3',
    /**
     * Candy-20
     */
    200: '#F9E8F1',
    /**
     * Candy-AA
     */
    A100: '#C96BA4',
};
/**
 * Zurich Power-Pink
 *
 * @property Power-Pink-100
 * @property Power-Pink-80
 * @property Power-Pink-60
 * @property Power-Pink-40
 * @property Power-Pink-20
 */
export const powderPink = {
    /**
     * Powder-Pink-100
     */
    100: '#FFC5EA',
    /**
     * Powder-Pink-20
     */
    800: '#FFD1EE',
    /**
     * Powder-Pink-20
     */
    600: '#FFDCF2',
    /**
     * Powder-Pink-20
     */
    400: '#FFE8F7',
    /**
     * Powder-Pink-20
     */
    200: '#FFF3FB',
};
/**
 * Zurich Lilac
 *
 * @property Lilac-100
 * @property Lilac-80
 * @property Lilac-60
 * @property Lilac-40
 * @property Lilac-20
 */
export const lilac = {
    /**
     * Lilac-100
     */
    100: '#6D6BCF',
    /**
     * Lilac-80
     */
    800: '#8A89D9',
    /**
     * Lilac-60
     */
    600: '#A7A6E2',
    /**
     * Lilac-40
     */
    400: '#C5C4EC',
    /**
     * Lilac-20
     */
    200: '#E2E1F5',
};
/**
 * Zurich Grey, Black, and White
 *
 * @property Grey-1
 * @property Grey-2
 * @property Grey-3
 * @property Grey-4
 * @property Grey-5
 * @property Grey-6
 * @property Grey-7
 * @property Grey-8
 * @property Grey-9
 * @property Black
 * @property White
 */
export const grey = {
    /**
     * Grey-1
     */
    100: '#0D1115',
    /**
     * Grey-2
     */
    200: '#2B2E31',
    /**
     * Grey-3
     */
    300: '#45484A',
    /**
     * Grey-4
     */
    400: '#5D6162',
    /**
     * Grey-5
     */
    500: '#74797A',
    /**
     * Grey-6
     */
    600: '#7F8788',
    /**
     * Grey-7
     */
    700: '#929A9C',
    /**
     * Grey-8
     */
    800: '#A6ADAF',
    /**
     * Grey-9
     */
    900: '#C9D0D2',
    /**
     * Black
     */
    50: '#000000',
    /**
     * White
     */
    A100: '#ffffff',
};
